import * as Yup from 'yup';
import { ComponentType } from 'react';

import { AutoBroadcastEnableSwitcher } from '../components/form/AutoBroadcastEnableSwitcher';
import { AutoBroadcastTextEditor } from '../components/form/AutoBroadcastTextEditor';
import { AutoBroadcastPeriodSelect } from '../components/form/AutoBroadcastPeriodSelect';
import {
    AutoBroadcast,
    AutoBroadcastValues,
} from '../service/autoBroadcast.interface';
import { AutoBroadcastImageUpload } from '../components/form/AutoBroadcastImageUpload';
import { TypeNames } from './options';

const commonValues = {
    is_enabled: false,
    text: '',
    send_after: null,
};

const initialValuesMap: Record<AutoBroadcast, AutoBroadcastValues> = {
    no_cart: {
        ...commonValues,
        type: 'no_cart',
    },
    no_order: {
        ...commonValues,
        type: 'no_order',
        image: null,
    },
};

export function getInitialValues(type: AutoBroadcast): AutoBroadcastValues {
    const values = initialValuesMap[type];
    if (!values) throw new Error(`Unknown AutoBroadcast type: ${type}`);
    return values;
}

export function getFormFields(type: AutoBroadcast): Array<{
    component: ComponentType<any>;
    fieldName: string;
    title?: string;
}> {
    const commonFields = [
        {
            component: AutoBroadcastEnableSwitcher,
            fieldName: 'is_enabled',
            title: TypeNames[type],
        },
        {
            component: AutoBroadcastTextEditor,
            fieldName: 'text',
        },
        {
            component: AutoBroadcastPeriodSelect,
            fieldName: 'send_after',
            title: 'Время отправки сообщения через (часы)',
        },
    ];

    if (type === 'no_order') {
        return [
            commonFields[0],
            {
                component: AutoBroadcastImageUpload,
                fieldName: 'image',
            },
            ...commonFields.slice(1),
        ];
    }

    return commonFields;
}

export const validationSchema = Yup.object().shape({
    is_enabled: Yup.boolean().required('Обязательное поле'),
});

export const timeVariants = [
    {
        key: 1,
        value: 1,
    },
    {
        key: 2,
        value: 2,
    },
    {
        key: 4,
        value: 4,
    },
    {
        key: 8,
        value: 8,
    },
    {
        key: 12,
        value: 12,
    },
    {
        key: 24,
        value: 24,
    },
];
